import { ImageService } from "@DavisDigital/davisdigitalfrontend.module";

class ImageCollectionShareModalController {
    
    private close:Function; //injected from modal-service
    public baseObject:any;
    public superUser: boolean;
    
    public sharedWithTeacher:any;
	public sharedWithStudent:any;
	public sharedAsDavisCollection:any;
	public sharedAsBookCollection:any;
    
    public title:string = "";
    public isLoading:boolean = false;
	
	// @ngInject
	constructor(
		public imageService   : ImageService
	){}
	
	public $onInit = () => {
        //initialize properties
        this.title = this.baseObject.title;
    	this.sharedWithTeacher = this.baseObject.sharedWithTeacher == 1;
    	this.sharedWithStudent = this.baseObject.sharedWithStudent == 1;
    	this.sharedAsDavisCollection = this.baseObject.daiImageSetFlag == 1;
    	this.sharedAsBookCollection = this.baseObject.bookImageSetFlag == 1;
	}
	
	
	public onCloseModal = () =>{
		this.close();
	}
	
	public onSubmitShare = () => {
		
		//return if isLoading is already true (it means another call is in process)
		if(this.isLoading){
			return;
		}
		//set isLoading to true (to prevent any other API call)
		this.isLoading = true;
		this.imageService.imageCollectionShare(this.baseObject.imageSetID, this.sharedWithStudent == 1, this.sharedWithTeacher == 1, this.sharedAsDavisCollection == 1, this.sharedAsBookCollection == 1).then( (result)=>{
			this.isLoading = false;
			if( result.successfulActions?.length ) {
				this.onCloseModal();
			}
		});
		
	}

}
    

class ImageCollectionShareModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    superUser: "<",
	    baseObject: "<",
		close:'='
	};

	public controller = ImageCollectionShareModalController;
	public controllerAs = 'shareModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/image-collection-share-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCollectionShareModal };
